<template>
  <div>
     <vue-header/>
            <loading :active.sync="isLoading"
          :can-cancel="false"
          :width = "50"
          :height = "50"
          :is-full-page="false">
          </loading>
     <div class="wd-container" style="margin-top: 15px;text-align:left;">
      <div class="container">
        <b-card  :header="'Jobs ('+jobListCount+')'">
        <!-- <button  v-b-toggle.collapse-2 class="btn" style="margin-bottom:5px;" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
          <i class="fas fa-filter" ></i> Filter/Sorting
        </button> -->
          <!-- <b-collapse id="collapse-2"> -->
          <div class="row">
          <span class="mb-2" style="margin-bottom:5px; margin-left:15px;">Filter by</span>
          </div>
          <div class="form-group" v-for="(input,k) in inputs" :id="k" :key="k">

            <div class="row">
              <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                <b-form-select :options="search_options" @change="changeDrop(input)" type="text" style="font-size: 11px;"  class="form-control" v-model="input.name"></b-form-select>

                </div>
              <div class="col-5" style="padding-right: 5px;padding-left: 5px;" v-if="input.date_flag == 0"><input type="text"  class="form-control" v-model="input.value"></div>
               <div class="col-5" style="padding-right: 5px;padding-left: 5px;" v-if="input.date_flag == 1"><datetime placeholder = "From Date"  auto v-model="input.from" format="MM/dd/yyyy"></datetime><datetime  placeholder = "To Date"  v-model="input.to" format="MM/dd/yyyy" auto></datetime></div>
              <div class="col-1 " style="padding-right: 5px;padding-left: 5px;"> <span>
                  <i class="fas fa-minus-circle" style="color:red;" @click="remove(k)" v-show="k == inputs.length-1 && inputs.length != 1"></i>
                  <i class="fas fa-minus-circle" style="color:red;margin-top: 12px;" @click="remove(k)" v-show="k != inputs.length-1"></i>
                  <i class="fas fa-plus-circle" style="color:#6495ed;" @click="add(input.id)" v-show="k == inputs.length-1 && inputs.length != 1"></i>
                  <i class="fas fa-plus-circle" style="    margin-top: 12px;color:#6495ed;" @click="add(input.id)" v-show="inputs.length == 1"></i>
              </span>
              </div>
            </div>
          </div>
          <div class="row">
          <span class="mb-2" style="margin-bottom:5px; margin-left:15px;">Sort by</span>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                <b-form-select :options="search_options" type="text" style="font-size: 11px;"  class="form-control" v-model="sort.name"></b-form-select>
              </div>
              <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                <b-form-select :options="sort_options" type="text" style="font-size: 11px;"  class="form-control" v-model="sort.order"></b-form-select>
              </div>
            </div>
          </div>
          <div class="row">
              <div class="col-2"></div>
            <div class="form-group col-4" style="text-align: center;margin-top:8px;padding-right: 5px;padding-left: 5px;">
                <button type="submit" class="btn btn-save" @click="applyFilter"> Apply  </button>
              </div>
              <div class="form-group col-4" style="text-align: center;margin-top:8px;padding-right: 5px;padding-left: 5px;">
                <button type="submit" class="btn btn-save" style="background-color: white;
color: black;" @click="resetFilter"> Reset  </button>
              </div>
              <div class="col-2"></div>
            </div>
          <!-- </b-collapse> -->
        </b-card>
          <b-card >
          <b-card-text>


              <table id="job_table" class="display" style="width:100%">
                <thead>
                    <tr>
                        <th class="all">Job Number</th>
                        <th class="all">Name</th>
                        <th class="none">Account Name</th>
                        <th class="none">Status</th>
                        <th class="none">Amount</th>
                        <th class="none">Last Update</th>
                        <th class="none">Primary Contact</th>
                        <th class="none">Bid Date</th>
                        <th class="none">Address</th>
                        <th class="none">Address 2</th>
                        <th class="none">City</th>
                        <th class="none">State</th>
                        <th class="none">Zip</th>
                        <th class="none">Billing Address</th>
                        <th class="none">Billing Address 2</th>
                        <th class="none">Billing City</th>
                        <th class="none">Billing State</th>
                        <th class="none">Billing Zip</th>
                        <th class="none">Estimator</th>
                        <th class="none">Project Manager</th>
                        <th class="none">Foreman</th>
                        <th class="none">Accountant</th>
                        <th class="none">Salesperson</th>
                        <th class="none">Lead Source</th>
                        <th class="none">{{cust_1}}</th>
                        <th class="none">{{cust_2}}</th>
                        <th class="none">{{cust_3}}</th>
                        <th class="none">{{cust_drop1}}</th>
                        <th class="none">{{cust_drop2}}</th>
                        <th class="none">{{cust_drop3}}</th>
                        <th class="none">Work Complete</th>
                        <th class="none">Progression Stage</th>
                        <th></th>
                    </tr>
                </thead>
            </table>
          </b-card-text>
        </b-card>
        <div class="btn-group-fab" role="group" aria-label="FAB Menu">
                <div>
                  <button @click="addNewJob" type="button" class="btn btn-main btn-primary has-tooltip" data-placement="left" title="Menu"> <i class="fa fa-plus" style="margin: 5px 0px 0px 0px;"></i> </button>
                </div>
              </div>
      </div>
     </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CommonConstants from '@/constants/constants.js'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
export default {
  name: 'JobListing',
  components : {Loading,Datetime},
  data() {
    return {
      constants: CommonConstants,
      isLoading:false,
      jobListCount:'',
      cust_1 : localStorage.getItem('cust1'),
      cust_2 : localStorage.getItem('cust2'),
      cust_3 : localStorage.getItem('cust3'),
      cust_drop1 : localStorage.getItem('cust_drop1'),
      cust_drop2 : localStorage.getItem('cust_drop2'),
      cust_drop3 : localStorage.getItem('cust_drop3'),
      inputs: [{name: '',value:'',id:0,date_flag:0,from:'',to:''}],
      sort : {name : "job_number", order:'Desc'},
      sort_options : ['Desc','Asc'],
      search_options : [{ value: '', text: 'Select Field',disabled: true },{value: 'job_number', text: 'Job Number'},{value: 'name', text: 'Name'},{value: 'account_name', text: 'Account Name'},{value: 'status', text: 'Status'},{value: 'amount', text: 'Amount'},{value: 'updated_at', text: 'Last Update'},{value: 'contact_name', text: 'Primary Contact'},{value: 'bid_date', text: 'Bid Date'},{value: 'site_address_1', text: 'Address'},{value: 'site_address_2', text: 'Address 2'},{value: 'site_city', text: 'City'},{value: 'site_state', text: 'State'},{value: 'site_zip', text: 'Zip'},{value: 'billing_address_1', text: 'Billing Address'},{value: 'billing_address_2', text: 'Billing Address 2'},{value: 'billing_city', text: 'Billing City'},{value: 'billing_state', text: 'Billing State'},{value: 'billing_zip', text: 'Billing Zip'},{value: 'estimator_name', text: 'Estimator'},{value: 'project_manager_name', text: 'Project Manager'},{value: 'foreman_name', text: 'Foreman'},{value: 'accountant_name', text: 'Accountant'},{value: 'salesperson_name', text: 'Salesperson'},{value: 'lead_source', text: 'Lead Source'},{value: 'custom_text_1', text: localStorage.getItem('cust1')},{value: 'custom_text_2', text: localStorage.getItem('cust2')},{value: 'custom_text_3', text: localStorage.getItem('cust3')},{value: 'custom_drop_1', text: localStorage.getItem('cust_drop1')},{value: 'custom_drop_2', text: localStorage.getItem('cust_drop2')},{value: 'custom_drop_3', text: localStorage.getItem('cust_drop3')},{value: 'completed_date', text: 'Work Complete'},{value: 'progress_status', text: 'Progression Stage'},]

    }
  },
  mounted : function(){
    let self = this;
    self.header = {
        'Content-type': "application/json",
        'token': localStorage.getItem('token')
    }
    self.getJobHeader();
    self.loadDTJobs();
    localStorage.setItem('previous_url','jobs');
  },
  methods :{
    changeDrop(val){
      console.log(val);
      let self= this;

        this.inputs.forEach(function(element,key) {
          if(element.id == val.id){
            if(val.name == 'updated_at' || val.name == 'bid_date' || val.name == "completed_date"){
              self.inputs[key].date_flag = 1;
            }else{
              self.inputs[key].date_flag = 0;
            }
          }
        });
        console.log(self.inputs);
    },
    resetFilter(){
      this.inputs = [{name: '',value:'',id:0,date_flag:0,from:'',to:''}];
      this.sort = {name : "job_number", order:'Desc'};
      this.loadDTJobs();
    },
    applyFilter(){
      let option_val = [];
      this.inputs.forEach(element => {
        if(element.name != '')
          option_val.push(element.name)
        if(element.from != '')
          element.from = moment(element.from).format('YYYY-MM-DD');
        if(element.to != '')
          element.to = moment(element.to).format('YYYY-MM-DD');
      });
      if(new Set(option_val).size !== option_val.length){
        Vue.$toast.error('Please remove duplicate field', {
            position: 'top'
            });
      }else{
        // $("#job_table").DataTable().destroy();
        // $('#job_table').empty();
        this.loadDTJobs();
      }

    },
    add(index) {
      let self = this;
        self.inputs.push({ name: '',value: '',id : index+1, date_flag:0,from:'',to:''});
    },
    remove(index) {
        this.inputs.splice(index, 1);
    },
    addNewJob (){
      this.$router.push('/job')
    },
    loadDTJobs(){
      var self = this;
      self.isLoading = true;
      $("#job_table").DataTable({
        processing: true,
        serverSide: true,
        responsive: {
            details: {
                type: 'column',
                target: -1,
                renderer: function ( api, rowIdx, columns ) {
                    var data = $.map( columns, function ( col, i ) {
                      if(col.title =='Name' || col.title =='Description'){
                        return col.hidden ?
                            '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                '<td><b>'+col.title+':'+'</b></td> '+
                                '<td style="white-space: normal;">'+col.data+'</td>'+
                            '</tr>' :
                            '';
                      }else{
                         return col.hidden ?
                            '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                '<td><b>'+col.title+':'+'<b></td> '+
                                '<td >'+col.data+'</td>'+
                            '</tr>' :
                            '';
                      }
                    } ).join('');

                    return data ?
                        $('<table/>').append( data ) :
                        false;
                }
            }
        },
        buttons: [
            {
                extend: 'colvis',
                columns: ':not(.noVis)',
                collectionLayout: 'fixed two-column',
                text: "<i class='fas fa-cog' ></i>"+"  Show/Hide Columns"
            }
        ],
        "ordering": false,
        columnDefs: [ {
            className: 'control',
            orderable: false,
            targets:   -1,
        },
        {
            targets: 32,
            className: 'noVis'
        }
        ],
        "dom": '<"top">Brit<"bottom"p><"clear">',
        "paging":   true,
        "pagingType": "simple_numbers",
        "pageLength": 25,
        destroy: true,
        colReorder: true,
        language: {
          emptyTable: "No record found.",
          search: "INPUT",
          searchPlaceholder: "Search records",
          processing: 'Loading...',
          // oPaginate: {
          //   sNext: '<i class="fas fa-angle-double-right"></i>',
          //   sPrevious: '<i class="fas fa-angle-double-left"></i>'
          // },
          sLengthMenu:
            "<label class='label_dropdown_dt'>Per page</label> MENU"
        },
        ajax: {
          headers: self.header,
          url: self.constants.api_url + "jobs/pwa",
          "data": function ( d ) {
             d.search_value = self.inputs;
             d.sort_value = self.sort;
          },
          dataType: "json",
          dataSrc: function (result) {
            console.log(result);
            //self.allTagsModel = result.data.approved_timesheets;
            self.jobListCount = result.recordsTotal;
            self.isLoading = false;
            return result.data;
          }
        },
        columns: [

          { data: "job_number", width : "50%",
            render: function(data, type, full, meta) {
              return (
                "<a href='/job/"+full.id+"'>"+full.job_number+"</a>"
              );
            }
          },
          { data: "name"},
          { data: "account_name" },
          {
            render: function(data, type, full, meta) {
              return (
                full.status ? full.status.charAt(0).toUpperCase() + full.status.slice(1) : ''
              );
            }
          },
          { data: "amount" },
          { data: "updated_at" },
          { data: "contact_name" },
          { data: "bid_date" },
          { data: "site_address_1" },
          { data: "site_address_2" },
          { data: "site_city" },
          { data: "site_state" },
          { data: "site_zip" },
          { data: "billing_address_1" },
          { data: "billing_address_2" },
          { data: "billing_city" },
          { data: "billing_state" },
          { data: "billing_zip" },
          { data: "estimate_name" },
          { data: "project_manager_name" },
          { data: "foreman_name" },
          { data: "accountant_name" },
          { data: "salesperson_name" },
          { data: "lead_source" },
          { data: "custom_text_1" },
          { data: "custom_text_2" },
          { data: "custom_text_3" },
          { data: "custom_drop_1" },
          { data: "custom_drop_2" },
          { data: "custom_drop_3" },
          { data: "completed_date" },
          {
            render: function(data, type, full, meta) {
              return (
                full.progress_status ? full.progress_status.charAt(0).toUpperCase() + full.progress_status.slice(1) : ''
              );
            }
          },
          {
            render: function(data, type, full, meta) {
              return (
                ''
              );
            }
          }
        ]
      });

      $("#job_table").on("page.dt", function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        $("th:first-child").focus();
      });
    },
    getJobHeader(){
        let self = this
        axios.get(self.constants.api_url + 'job/get/get_customfields',{headers : self.header})
        .then(function(res){
          localStorage.setItem('jobCustomfieldHeaders', JSON.stringify(res.data));
          localStorage.setItem('cust1', res.data.company_custom_text1);
          localStorage.setItem('cust2', res.data.company_custom_text2);
          localStorage.setItem('cust3', res.data.company_custom_text3);
          localStorage.setItem('cust_drop1', res.data.company_custom_drop_1);
          localStorage.setItem('cust_drop2', res.data.company_custom_drop_2);
          localStorage.setItem('cust_drop3', res.data.company_custom_drop_3);
        })
        .catch(function (error) {
          })
      }
  },
  watch : {
      inputs (val){
        let option_val = [];
        val.forEach(element => {
          if(element.name != '')
            option_val.push(element.name)
        });
      }
  }
}
</script>

<style>
table.dataTable.dtr-column>tbody>tr>td.control:before {
  font-family: "Font Awesome 5 Free" !important;
  font-weight: 900; content: "\f13a "!important;
  background-color: white !important;
  color: #6495ED !important;
  box-shadow: none !important;
  border : none !important;
  cursor: pointer;
  line-height: 16px !important;
}
table.dataTable.dtr-column>tbody>tr.parent td.control:before {
    content: '\f139' !important;
    color: #d33333 !important;
    line-height: 16px !important;
}
</style>
